"use client";

import LandingPageLayout from "@/components/layout/LandingPageLayout";
import { WHAT_WE_STAND_FOR } from "@/utils/constants";
import Image from "next/image";

const Company = () => {
  return (
    <LandingPageLayout>
      <main className="lg:p-20 lg:pb-0 md:pb-0 pb-0 md:p-12 p-6 space-y-12">
        <div className="flex flex-col items-center">
          <h2 className="mb-2 md:text-3xl text-2xl font-semibold">
            Who We Are
          </h2>
          <p className="text-center lg:w-[60%] md:text-base text-sm font-medium mb-8">
            Founded with the vision to redefine cooperative finance for the modern generation, 
            with a focus on empowering communities to achieve their collective financial goals, 
            we blend technology, transparency, and trust to create a seamless and engaging experience 
            for all cooperative members and leaders.
          </p>
          <Image src="/whoweare.png" alt="img" width={800} height={200} />
        </div>

        <section className="md:space-y-8 space-y-6">
          <div>
            <h2 className="font-semibold md:text-2xl text-base">Mission</h2>
            <p className="text-primary text-base lg:text-2xl lg:leading-[40px] leading-[30px]">
              To digitize Africa&apos;s cooperative financial communities, eliminating manual errors 
              and operational losses while empowering millions of members to save, invest, and access 
              credit through secure, transparent technology that builds trust and drives collective 
              prosperity.
            </p>
          </div>
          <div>
            <h2 className="font-semibold md:text-2xl text-base">Vision</h2>
            <p className="text-primary text-base lg:text-2xl lg:leading-[40px] leading-[30px]">
              To become Africa&apos;s leading cooperative financial ecosystem, transforming how 
              100+ million cooperative members across the continent save, invest, and build wealth 
              together.
            </p>
          </div>
        </section>
        <section className="flex flex-col items-center lg:pt-16 pt-8">
          <h2 className="mb-2 md:text-3xl text-2xl font-semibold">
            What We Stand For
          </h2>
          <p className="text-center lg:w-[60%] md:text-base text-sm font-medium mb-8">
            We are driven by principles that define who we are and guide
            everything we do. These values are the foundation of our commitment
            to you, our users, and to the future we aim to build together:
          </p>
          <div className="grid md:grid-rows-2 md:grid-cols-3 grid-cols-1 gap-6">
            {WHAT_WE_STAND_FOR.map(({ img, title, description }, index) => {
              return (
                <div key={index}>
                  <Image src={img} alt="img" width={400} height={300} />
                  <div className=" bg-[#D0F5EE] p-4 space-y-2">
                    <h3 className="font-semibold md:text-base text-sm">
                      {title}
                    </h3>
                    <p className="md:text-sm text-xs">{description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      </main>
    </LandingPageLayout>
  );
};

export default Company;
